import axios from 'axios'

export default {
  /**
   * Get full hierarchy tree with product counts
   * GET /api/admin/brands-tree
   */
  getBrandsTree(cancelToken = null) {
    const config = {}
    if (cancelToken) {
      config.cancelToken = cancelToken
    }
    return axios.get('/api/admin/brands-tree', config)
  },

  /**
   * Get independent lists for dropdown options
   * GET /api/admin/hierarchy/dropdown-options
   */
  getDropdownOptions() {
    return axios.get('/api/admin/hierarchy/dropdown-options')
  },

  /**
   * Create new hierarchy combination
   * POST /api/admin/hierarchy
   */
  createHierarchy(payload) {
    return axios.post('/api/admin/hierarchy', payload)
  },

  /**
   * Update hierarchy entity
   * PATCH /api/admin/hierarchy/{id}
   */
  updateHierarchy(id, payload) {
    return axios.patch(`/api/admin/hierarchy/${id}`, payload)
  },

  /**
   * Delete hierarchy entity
   * DELETE /api/admin/hierarchy/{id}
   */
  deleteHierarchy(id, payload) {
    return axios.delete(`/api/admin/hierarchy/${id}`, { data: payload })
  },

  /**
   * Copy products to new hierarchy
   * POST /api/admin/hierarchy/products/copy
   */
  copyProducts(payload) {
    return axios.post('/api/admin/hierarchy/products/copy', payload)
  },

  /**
   * Move products to new hierarchy
   * POST /api/admin/hierarchy/products/move
   */
  moveProducts(payload) {
    return axios.post('/api/admin/hierarchy/products/move', payload)
  }

}
